import {useMutation, UseMutationResult} from '@tanstack/react-query';
import Api from 'types/api';
import {request} from 'utils/request';

export type RefreshErrorResponse = Api.Response.Failure<unknown>;

export type RefreshSuccessResponse<T> = Api.Response.Success<T>;

const useBackendRefresh = <T>(): UseMutationResult<
    RefreshSuccessResponse<T>,
    RefreshErrorResponse,
    string
> => {
    const locale = 'en'; //useLocale();

    return useMutation({
        mutationFn: (uri) => request({locale, method: 'GET', uri}),
    });
};

export default useBackendRefresh;
